import type {
  CallbackFn,
  DatabaseService,
  PricingConfiguration,
  PricingConfigurationData,
  PricingConfigurationRepository,
} from "@core";
import { pricingConfigurationSchema } from "@core/entities/pricing-configuration";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

const parse = (data: unknown): PricingConfiguration =>
  pricingConfigurationSchema.parse(data);

export const getPricingConfigurationRepository = (
  databaseService: DatabaseService,
): PricingConfigurationRepository => {
  const repository = getGenericRepository<
    PricingConfiguration,
    PricingConfigurationData
  >(
    () => DatabaseCollection.PRICING_CONFIGURATIONS,
    databaseService,
  );

  return {
    ...repository,
    async get(payload: { id: string }) {
      const result = await repository.get(payload);
      return result ? parse(result) : null;
    },
    subscribe(payload: { id: string; callback: CallbackFn<PricingConfiguration> }) {
      return repository.subscribe({
        ...payload,
        callback: (entry) => {
          if (!entry) {
            payload.callback(null);
            return;
          }

          payload.callback(parse(entry));
        },
      });
    },
  };
};
